module.exports = __webpack_public_path__ + "static/media/bath.1707cedf.svg";